/**
 * @file Highway object containing all parts of the script.
 * @author Anthony Du Pont <bulldog@dogstudio.co>
 */
import Core from './core';
import Helpers from './helpers';
import Renderer from './renderer';
import Transition from './transition';

// Highway Version
console.log('Highway v2.2.0');

// Export Highway
export default {
  Core,
  Helpers,
  Renderer,
  Transition
};
